import { createAction } from "@reduxjs/toolkit";

export const failNoomClinicalAgeValidation = createAction(
  "paymentEnrollmentForm/failNoomClinicalAgeValidation"
);

export const closeIneligibleAgeModal = createAction(
  "paymentEnrollmentForm/closeIneligibleAgeModal"
);
